import React, { FunctionComponent } from "react";
import { ThemeProvider } from "@material-ui/core";
import { theme } from "styles/theme";
import themeV0 from "styles/theme_v0";
import { MuiThemeProvider as V0MuiThemeProvider } from "material-ui/styles";

const MuiThemeProviderBase: FunctionComponent = ({ children }) => (
    <ThemeProvider theme={theme}>
        <V0MuiThemeProvider muiTheme={themeV0}>{children}</V0MuiThemeProvider>
    </ThemeProvider>
);

export default MuiThemeProviderBase;
